import _ from 'lodash'

import { usePatents } from 'src/patents/PatentsProvider'
import { IpRightsContext } from 'src/renewal/interfaces/IpRights'
import { IpRight } from 'src/renewal/interfaces/renewal_types'
import { Instruction, useDennemeyer, useInvalidateMaintenances, useSynchronize, useTimeline } from '../DennemeyerProvider'
import { pass_through, post_instructions } from '../dennemeyer_backend'
import { dmIpRightToIpRight, getOwnerAndCostCenters } from './utils'
import { isOpen } from '../settings/instruction_timeline'

export function DennemeyerIpRightsProvider({ children }: { children: React.ReactNode }) {
  const { memberById } = usePatents()
  const {
    ipRights: pcIpRights,
    ipRightById: pcIpRightById,
    costCentersByIpRightId,
    ownershipsByIpRight,
    invalidateIpRights,
    postInstruction, 
    postIpRight: pcPostIpRight,
  } = useDennemeyer()

    const {calculateDueDates} = useTimeline()
    const { invalidateMaintenances } = useInvalidateMaintenances()

    const {triggerSynchronize, synchronizing} = useSynchronize()
  // const {ipRights: dmIpRights} = useIpRightsPortfolio()

  // const dmIpRightById = _.keyBy(dmIpRights, ipr => ipr.DennemeyerId)

  const ipRights: (IpRight & { familyMemberId: number })[] = pcIpRights.map(ipRight => {
    const member = memberById[ipRight.familyMemberId]
    const { owner, costCenters } = getOwnerAndCostCenters(ipRight, ownershipsByIpRight, costCentersByIpRightId)
    return dmIpRightToIpRight(ipRight, member, owner, costCenters)
  })

  const ipRightById = _.keyBy(ipRights, ipr => ipr.id)
  // console.log({ pcIpRights, ipRights, ipRightById })
  const ipRightByFamilyMemberId = _.keyBy(ipRights, ipr => ipr.familyMemberId)

  // TODO: Fix this. Make sure all the info is propagated
  //function forPostIpRight(ipr: IpRight, familyMemberId?: number) {
  //  const member = memberById[familyMemberId]
  //  const status: DmStatus =
  //    member?.familyMemberStatus === 'pending' ? 'Pending' : member?.familyMemberStatus === 'granted' ? 'Granted' : 'Inactive'
  //  const parent = parents[familyMemberId]?.[0]?.familyMemberId
  //  return {
  //    familyMemberId,
  //    ipRightId: parseNumber(ipr.clientUniqueId),
  //    // TODO: sub type, UP 
  //    ipType: 'patent',
  //    ipSubType: 'patent',
  //    origin: 'National',
  //    parent,
  //    status,
  //    dennemeyerId: ipr.id,
  //    ownerId: ipr.owner,
  //    costCenters: _(ipr.costCenters)
  //      .map((percentage, costCenterId) => ({ costCenterId: parseNumber(costCenterId), percentage }))
  //      .value(),
  //  }
  //}

  // TODO postIpRight, postIpRights, deriveInitial
  //async function postIpRight(ipRight: IpRight, familyMemberId?: number) {
  //  const dmIpRights: PostIpRight[] = [forPostIpRight(ipRight, familyMemberId)]
  //  await post_ip_right_to_dennemeyer(dmIpRights)
  //  //reload()
  //  reloadPc()
  //  invalidateIpRights()
  //}

  //async function postIpRights(ipRights: { ipRight: IpRight; familyMemberId?: number }[]) {
  //  const dmIpRights: PostIpRight[] = ipRights.map(({ ipRight, familyMemberId }) => forPostIpRight(ipRight, familyMemberId))
  //  await post_ip_right_to_dennemeyer(dmIpRights)
  //  //reload()
  //  reloadPc()
  //  invalidateIpRights()
  //}

  async function stopIpRight(_ipRight: IpRight) {
    const pcIpRight = pcIpRightById[_ipRight.clientUniqueId]
    const ipRightId = pcIpRight?.ipRightId

    const ipRightData = await pass_through(`/v1.2/api/portfolio/by-id/${pcIpRight.dennemeyerId}`)

    // const { ipRight: ipRightData, isLoading } = useIpRight(pcIpRight?.dennemeyerId)
    const dmIpRight = ipRightData?.Data

    const openMaintenanceActions = _(dmIpRight?.MaintenanceActions ?? [])
      .map(m => ({ ...m, ...calculateDueDates(m.DueDate) }))
      .filter(m => isOpen(m.status))
      .value()

    if (openMaintenanceActions.length > 0) {
      const instructions = openMaintenanceActions.map(ma => ({ DennemeyerId: ma.DennemeyerId, Instruction: ('Cancel' as Instruction)}))
      await post_instructions(instructions)
      await Promise.all(instructions.map(i => postInstruction({ ipRightId, dennemeyerId: i.DennemeyerId, instruction: i.Instruction })))
      invalidateMaintenances()
    }
    await pcPostIpRight({ ...pcIpRight, status: 'Inactive' })
    triggerSynchronize([ipRightId])
    invalidateIpRights()
  }

  //function deriveInitial(member: Member): IpRight {
  //  const pcIpRight = member.unitaryPatent ? upIpRightByMemberId[member.familyMemberId] : pcIpRightByMemberId[member.familyMemberId]
  //  const owner = ownershipsByIpRight[pcIpRight?.ipRightId]?.[0]?.ownerId ?? fallbackOwnerId
  //  const costCenters = _(costCentersByIpRightId[pcIpRight.ipRightId] ?? [])
  //    .map(cc => [cc.costCenterId, cc.percentage])
  //    .fromPairs()
  //    .value()
  //  return {
  //    id: pcIpRight?.dennemeyerId,
  //    clientReference: member.internalReference,
  //    clientUniqueId: '' + pcIpRight?.ipRightId,
  //    publicationNumber: member.publicationNumber,
  //    grantNumber: member.patentNumber,
  //    status: 'Processing',
  //    costCenters,
  //    owner,
  //  }
  //}

  const value = {
    ipRights,
    ipRightById,
    ipRightByFamilyMemberId,
    // deriveInitial,
    // postIpRight,
    // postIpRights,
    stopIpRight,
  }
  return <IpRightsContext.Provider {...{ value }}>{children}</IpRightsContext.Provider>
}